"use client";
import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import styled from "styled-components";
import { sans } from "@churchofjesuschrist/eden-style-constants";
const Button = styled.button`
  background: 0;
  border: 0;
  padding: 0;
  margin: 0;
  text-align: inherit; /* user agent sets to center, override */
  cursor: pointer;
  color: inherit;
  font-family: ${sans};
  text-decoration: none;

  &[disabled] {
    cursor: not-allowed;
  }
`;
const A11yComponent = ({
  href,
  disabled,
  renderAs = href && !disabled ? "a" : "button",
  type = renderAs === "button" ? "button" : void 0,
  ...props
}, ref) => /* @__PURE__ */ jsx(
  Button,
  {
    ...props,
    ref,
    type,
    href,
    disabled,
    as: renderAs,
    children: props.children
  }
);
const A11y = forwardRef(A11yComponent);
A11y.displayName = "A11y";
var A11y_default = A11y;
export {
  A11y_default as default
};
